// extracted by mini-css-extract-plugin
module.exports = {"scrollSlider":"ScrollSlider_scrollSlider__rbDwF"};